document.addEventListener('turbolinks:load', () => {
  // Wait for filter_form to be initialized
  if (!window.filter_form) {
    setTimeout(() => {
      initializeKeyIncidents();
    }, 100);
    return;
  }
  
  initializeKeyIncidents();
});

function initializeKeyIncidents() {
  if ($('#key_incidents_customer_id').length > 0) {
    $('#key_incidents_customer_id').on('change', function() {
      let customerID = $('#key_incidents_customer_id').val()

      if (customerID) {
        $('#q_season_id_eq').val('')
        if (window.filter_form) {
          window.filter_form.showSeasons(customerID);
        }
        $('#q_fixture_id_eq').val('')
        if (window.filter_form) {
          window.filter_form.showCompetitions(customerID);
        }
      } else {
        $('#q_season_id_eq').val('')
        $('#q_fixture_id_eq').val('')
        $('#q_competition_id_eq').find("option").remove();
      }
    });

    // Initialize fields if customer is already selected AND fields are empty
    const customerID = $('#key_incidents_customer_id').val();
    if (customerID && window.filter_form) {
      // Only populate Season if it's empty
      if ($('#q_season_id_eq option').length <= 1) {
        window.filter_form.showSeasons(customerID);
      }
      // Only populate Competition if it's empty
      if ($('#q_competition_id_eq option').length <= 1) {
        window.filter_form.showCompetitions(customerID);
      }
    }
  } else if ($('#q_competition_id_eq').length > 0) {
    const customerID = $('#q_competition_id_eq').data('customer-id');
    if (customerID && window.filter_form) {
      // Only populate Competition if it's empty
      if ($('#q_competition_id_eq option').length <= 1) {
        window.filter_form.showCompetitions(customerID);
      }
    }
  }

  $('.key_incident_season_id_eq').on('change', function() {
    let seasonID = $('.key_incident_season_id_eq').val()

    if (seasonID && window.filter_form) {
      window.filter_form.showFixturesBySeason(seasonID);
    }
  });
}

